import {HaciendaItem, HaciendaState} from './types'
export const state: HaciendaState={
    haciendas: Array<HaciendaItem>()
}